import type { Negocio } from "./tipos";

/**
 * Leads = pendientes de llamar (Robert, 02/10/2026): proyecto de Ventas en «Lead nuevo» y
 * sin «no volver a contactar». Es el filtro de la lista Leads (vista negocios_estado) y la
 * cifra «Leads pendientes» del Inicio: una sola regla para que nunca vuelvan a no
 * coincidir (lo destapó el inventario del 01/10).
 */
export const FILTRO_LEADS = {
  embudo: "ventas",
  etapa: "nuevo",
  no_llamar: false,
  // S9: los negocios que Prospect descubre y aún no ha entregado no son leads para llamar.
  en_leads: true,
} as const;

export const esLeadPendiente = (
  n: Pick<Negocio, "embudo" | "etapa" | "no_llamar" | "en_leads">,
) =>
  n.embudo === FILTRO_LEADS.embudo &&
  n.etapa === FILTRO_LEADS.etapa &&
  n.no_llamar === FILTRO_LEADS.no_llamar &&
  n.en_leads !== false;
